<ag-grid-angular
  id="regionTaxRateHistoryGrid"
  class="ag-theme-quartz margin-top-med margin-bottom-med"
  data-testid="region-tax-rate-history-grid"
  [tooltipShowDelay]="0"
  rowClass="table-row"
  domLayout="autoHeight"
  overlayNoRowsTemplate="<span>No tax rate history found for this region</span>"
  [postSortRows]="postSortRows"
  (firstDataRendered)="onFirstDataRendered($event)"
  (gridSizeChanged)="onGridSizeChanged($event)"
  [loading]="uiState == uiStateEnum.ShowLoading"
  [rowData]="taxRates"
  [columnDefs]="columnDefs"
  [context]="gridContext">
</ag-grid-angular>
